// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TimingAPIModel,
    TimingAPIModelFromJSON,
    TimingAPIModelFromJSONTyped,
    TimingAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface PreparedFpsTransferAPIModel
 */
export interface PreparedFpsTransferAPIModel {
    /**
     * 
     * @type {string}
     * @memberof PreparedFpsTransferAPIModel
     */
    messageId: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedFpsTransferAPIModel
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof PreparedFpsTransferAPIModel
     */
    fee: string;
    /**
     * 
     * @type {TimingAPIModel}
     * @memberof PreparedFpsTransferAPIModel
     */
    timing: TimingAPIModel;
}

export function PreparedFpsTransferAPIModelFromJSON(json: any): PreparedFpsTransferAPIModel {
    return PreparedFpsTransferAPIModelFromJSONTyped(json, false);
}

export function PreparedFpsTransferAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreparedFpsTransferAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'amount': json['amount'],
        'fee': json['fee'],
        'timing': TimingAPIModelFromJSON(json['timing']),
    };
}

export function PreparedFpsTransferAPIModelToJSON(value?: PreparedFpsTransferAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'amount': value.amount,
        'fee': value.fee,
        'timing': TimingAPIModelToJSON(value.timing),
    };
}


